export default __webpack_public_path__ + "static/media/p2023-32.1f1fa379.jpeg";